import React from 'react';
interface HubFaqsProps {
  faqs: {
    question: string;
    answer: string;
  }[];
}
export function HubFaqs({
  faqs
}: HubFaqsProps) {
  return <section id="faq" aria-labelledby="faq-h" className="border-t border-line bg-white" data-id="element-119" data-mp="1gw8kln1707zf">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-120" data-mp="1umvcav8jcxm0">
        <h2 id="faq-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-121" data-mp="1qmbbnhor7bv4">
          Parent questions
        </h2>
        <dl className="mt-12 max-w-3xl border-t border-line" data-id="element-122" data-mp="xyfi2luhe02k">
          {faqs.map(f => <div key={f.question} className="border-b border-line py-7" data-id="element-123" data-mp="1bxfa83h7cx3h">
              <dt className="font-display text-[23px] font-400 text-ink" data-id="element-124" data-mp="1bvau8n6147mu">
                {f.question}
              </dt>
              <dd className="mt-3 max-w-prose text-[15.5px] leading-[1.85] text-muted" data-id="element-125" data-mp="2nckdp9p5qzo5">
                {f.answer}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}